module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jascc-8d8fbffe1862c73e739f2147c934768a.svg";